// client/src/components/unidades/UnidadeRow.js
import React from 'react';
import { MoreVertical, CheckCircle, XCircle } from 'lucide-react';

const UnidadeRow = ({ unidade, onOpenActions }) => {
    const isAtivo = unidade?.ativo !== false;

    const localidade = [
        unidade?.endereco?.localidade,
        unidade?.endereco?.uf
    ].filter(Boolean).join('/');

    return (
        <tr className={`table-row-hover ${!isAtivo ? 'opacity-60 bg-gray-50' : ''}`}>
            {/* NOME DA UNIDADE */}
            <td className="td-name">
                <div className="text-sm font-medium text-gray-900 flex items-center gap-2">
                    {unidade?.nome || 'Unidade sem nome'}
                </div>
            </td>
            
            {/* LOCALIDADE / UF */}
            <td className="text-sm text-gray-600 font-medium">
                {localidade || '-'}
            </td>
            
            {/* STATUS */}
            <td className="text-center">
                <div className="flex items-center justify-center">
                    {isAtivo ? (
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                            <CheckCircle size={12} className="mr-1" /> Ativo
                        </span>
                    ) : (
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 border border-red-200">
                            <XCircle size={12} className="mr-1" /> Inativo
                        </span>
                    )}
                </div>
            </td>
            
            {/* AÇÕES */}
            <td className="text-right">
                <div className="flex justify-end">
                    <button
                        onClick={() => onOpenActions(unidade)}
                        className="action-icon-button text-gray-600"
                        title="Ações"
                        type="button"
                    >
                        <MoreVertical size={18} />
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default UnidadeRow;